// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* Indeterminate \"preparing\" progress sweep */\n.uppy-prep-bar[data-v-91b7a160] { animation: uppy-prep-91b7a160 1.1s ease-in-out infinite;\n}\n@keyframes uppy-prep-91b7a160 {\n0% { transform: translateX(-120%);\n}\n100% { transform: translateX(320%);\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
